import React, { useState } from 'react';
import {
  SelectChangeEvent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Box,
} from '@mui/material';
import { CalcSupportsForTiles } from './CalcSupportsForTiles';
import { CalcSupportsForTimber } from './CalcSupportsForTimber';
import { Edit } from '../../constructor/work/Edit';

enum MODE_VIEW {
  Tile,
  Timber,
}

export const WrapperCalculateSupports = () => {
  const [modeCalculation, setModeCalculation] = useState(() => {
    const mode = sessionStorage.getItem('mode');
    if (mode) {
      return +mode;
    }
    return MODE_VIEW.Timber;
  });
  const [isDisable, setIsDisable] = useState(
    () => !!Edit.supportsGroup || !!Edit.supportsGroupTimber
  );

  const handleChange = (event: SelectChangeEvent) => {
    setModeCalculation(+event.target.value);
    sessionStorage.setItem('mode', event.target.value);
  };

  return (
    <Stack height="100%">
      <Typography fontSize={24} color="#fff" mb={2}>
        ШАГ 4
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        sx={{
          overflow: 'hidden',
          overflowY: 'auto',
          padding: '5px 10px',
        }}
      >
        <FormControl
          disabled={isDisable}
          sx={{
            marginBottom: '20px',
            '&.Mui-disabled': {
              color: '#6e6e6e',
            },
            '& .MuiFormLabel-root.MuiInputLabel-root': {
              color: '#fff',
              '&.Mui-disabled': {
                color: '#6e6e6e',
              },
            },
            '& .MuiOutlinedInput-root': {
              color: '#fff',
              '&.Mui-disabled': {
                color: '#6e6e6e',
              },
              '& fieldset': {
                borderColor: '#fff',
              },
              '&:hover fieldset': {
                borderColor: 'rgb(217,255,78)',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#ffffff',
              },
            },
            '& .MuiSvgIcon-root.MuiSelect-icon': {
              color: '#fff',
              '&.Mui-disabled': {
                color: '#6e6e6e',
              },
            },
          }}
          fullWidth
        >
          <InputLabel color="info" id="demo-simple-select-label">
            Просчет
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={modeCalculation.toString()}
            label="Просчет"
            color="secondary"
            onChange={handleChange}
          >
            <MenuItem
              sx={{
                '&.Mui-selected ': {
                  backgroundColor: 'rgba(2,160,217,0.45)',
                },
              }}
              value={MODE_VIEW.Tile}
            >
              Расчёт под керамо-гранитные плиты
            </MenuItem>
            <MenuItem
              sx={{
                '&.Mui-selected ': {
                  backgroundColor: 'rgba(2,160,217,0.45)',
                },
              }}
              value={MODE_VIEW.Timber}
            >
              Расчёт под террасную доску
            </MenuItem>
          </Select>
        </FormControl>
        {modeCalculation === MODE_VIEW.Tile && (
          <CalcSupportsForTiles setDisableRootControl={val => setIsDisable(val)} />
        )}
        {modeCalculation === MODE_VIEW.Timber && (
          <CalcSupportsForTimber setDisableRootControl={val => setIsDisable(val)} />
        )}
      </Box>
    </Stack>
  );
};
